// Empreintes anonymes (cyrb53 de l'email OU du username, minuscules) des clients du
// PILOTE « État des lieux » : les ~92 clients les plus actifs (top 5% des abonnés,
// cohorte du 02/07) + pilotes nommés par Charly. AUCUN email en clair (même principe
// que pilotHashes.js). Ces comptes voient la fonctionnalité État des lieux (badge NEW).
// Élargir le pilote = ajouter des empreintes ici, ou monter VITE_APP_EDL_ROLLOUT_PERCENT.

// Empreinte non réversible (cyrb53), identique à useTopBarPreview.js / pilotHashes.
function cyrb53(str) {
  let h1 = 0xdeadbeef
  let h2 = 0x41c6ce57
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i)
    h1 = Math.imul(h1 ^ ch, 2654435761)
    h2 = Math.imul(h2 ^ ch, 1597334677)
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909)
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909)

  return 4294967296 * (2097151 & h2) + (h1 >>> 0)
}

const EDL_PILOT_HASHES = new Set([
  '1436269031234180',
  '8378841925061441',
  '102740041023835',
  '1030500474247180',
  '1067824216400117',
  '1072978812494061',
  '1169067791775384',
  '1242056339633694',
  '132066709617338',
  '1329331747770575',
  '1505450977119880',
  '152920968206576',
  '1619270338385039',
  '1628286033254391',
  '1718576764473191',
  '1727412324905508',
  '1743911614446922',
  '1797572754466754',
  '180033217196728',
  '1855409629122230',
  '1959383017929220',
  '1989551485819326',
  '1989926693378315',
  '1999479929003900',
  '2013839728377093',
  '2041828457002444',
  '2095197684371126',
  '2163431102991434',
  '2262388404903892',
  '2321704470770825',
  '2359452645824601',
  '2385087026231422',
  '2387965634370766',
  '2428350302689003',
  '2530356715927371',
  '2550376602353078',
  '2564915049255357',
  '2594847863837300',
  '2640991837985700',
  '2780302718123699',
  '2798245640006399',
  '2801931445872084',
  '2808066846839653',
  '2810132048977806',
  '2827284584933125',
  '2942981734589415',
  '2998779429574900',
  '3012376235394572',
  '3157434605176563',
  '3374503072762010',
  '3451110850412587',
  '3477554178994360',
  '3485231140433747',
  '350240391701425',
  '3615322755423410',
  '3672268014311103',
  '370847592192051',
  '3723528173849808',
  '3761167658501884',
  '3872747543469835',
  '391522424133661',
  '3933412225253841',
  '3989622180301806',
  '399747330561649',
  '4067212113460057',
  '4234479112973910',
  '439930956067592',
  '4461584093039702',
  '4467372767789232',
  '4480352344256253',
  '4482933795428675',
  '448877919979817',
  '4608161814502162',
  '4615908647384009',
  '4662699678196329',
  '4736048570474087',
  '4744088188692603',
  '4824129628064135',
  '4827786248610581',
  '4832577562125329',
  '4931597478846400',
  '4938587935009982',
  '5023082646272709',
  '5053475015145663',
  '5063932444489907',
  '5065164224610122',
  '513388201529575',
  '5189227195793424',
  '5193677312228736',
  '521725761269418',
  '5266020062343373',
  '5289754636111943',
  '5376189207702305',
  '5446456663301475',
  '5448007459359189',
  '5450871886657692',
  '5550007110325406',
  '561268134322220',
  '5625176366308422',
  '5674560936493941',
  '5721707599151256',
  '5728969361682906',
  '5740494153698056',
  '5807954511601384',
  '581279879454306',
  '5826575923676779',
  '5834472406679913',
  '583802138558708',
  '5838247736049927',
  '5853461869621023',
  '5933809531490892',
  '5953807035036551',
  '5969244197866790',
  '597922753321290',
  '6013390119773620',
  '6131962534887799',
  '6233959084814493',
  '6237225517533763',
  '6262538364289201',
  '6293221182990937',
  '6339318375838064',
  '6417884069296069',
  '6447240801469404',
  '645200081649055',
  '6493096513728606',
  '6527282126710818',
  '6595727783294069',
  '6608100838919445',
  '6622085314746822',
  '6687410906020871',
  '6751071887597454',
  '6760780391321426',
  '6820730950912463',
  '6827053051502827',
  '6915567521240394',
  '6952417786978491',
  '7021565422393338',
  '7117813492145741',
  '7118175095482137',
  '7160601900920593',
  '7194425181063221',
  '7236390750466328',
  '7242884944402462',
  '7255210602545903',
  '7274839281445008',
  '7284256308683255',
  '7317661875030425',
  '7393406044307650',
  '7415224184748255',
  '7416261652213074',
  '7476445336193050',
  '7527821824809980',
  '7600235285802335',
  '7679587244863392',
  '7680783113875057',
  '7689657025001422',
  '7717283306482056',
  '7724516489253065',
  '7750134154616458',
  '7874669466243816',
  '7928463369512199',
  '7953249637135464',
  '7954180078354210',
  '8079621357850237',
  '8085890688039253',
  '8114540720193440',
  '8120656263251534',
  '8187772196939932',
  '827147113223552',
  '8286711486130064',
  '8421780618345969',
  '8473737583694283',
  '8529129974392914',
  '8602626676240375',
  '8657817768435612',
  '8690943882922973',
  '8697015779517833',
  '8709747440321398',
  '8781731808642002',
  '8860517397664083',
  '8872219604344125',
  '8882748279410888',
  '888682417847874',
  '8889842085060230',
  '919822893303297',
])

// true si l'identifiant (email ou username, sera minusculisé) fait partie du pilote EDL.
export function isEdlPilot(identifier) {
  const id = (identifier || '').trim().toLowerCase()
  if (!id) return false

  return EDL_PILOT_HASHES.has(String(cyrb53(id)))
}
